import parse from 'html-react-parser';
import React, { useContext } from 'react';
import { subjectTypes } from '../../@types/entities/subjects.entity';
import { Container } from './styles';
import { NotesContext } from '../../contexts/NotesContext';

export type IQuote = {
  title: string;
  content: string;
  font: string;
  subject: subjectTypes | string;
};

const COLOR = 20;

export default function Quotations({ title, content, font, subject }: IQuote) {
  const { replace } = useContext(NotesContext);

  return (
    <Container $subject={subject} $color={COLOR}>
      {title && <h4>{title}</h4>}
      {typeof content === 'string' ? parse(content, { replace }) : content}
      {font && <p>{`Fonte: ${font}`}</p>}
    </Container>
  );
}
